export const SEARCH_MIN_QUERY_LENGTH = 2;
export const SEARCH_DEBOUNCE_DELAY = 500;
export const SEARCH_RESULTS_LIMIT = 10;
export const SEARCH_SNIPPET_CONFIG = {
    contextBeforeMatch: 18,
    maxVisibleLength: 160,
    ellipsis: "…"
};
